import React from 'react';
import { Shield, Scale, Target, Users } from 'lucide-react';

const iconMap = {
  1: Shield,
  2: Scale,
  3: Target,
  4: Users
};

const Values = ({ values }) => {
  return (
    <section id="values" className="section-container">
      <div className="content-wrapper">
        <h2 className="section-title">Наші цінності</h2>
        <div className="values-grid">
          {values.map((value) => {
            const Icon = iconMap[value.id] || Shield;
            return (
              <div key={value.id} className="value-card">
                <div className="value-icon">
                  <Icon size={32} />
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
